import { render, staticRenderFns } from "./SkupTema2Edit.vue?vue&type=template&id=627cdb52&scoped=true&"
import script from "./SkupTema2Edit.vue?vue&type=script&lang=js&"
export * from "./SkupTema2Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627cdb52",
  null
  
)

export default component.exports